import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Cómo recibo el material después de comprar?',
  answer: 'Inmediatamente después de confirmar el pago recibís un email con el acceso a todos los PDFs. En menos de 5 minutos tenés todo disponible para descargar y empezar a usar.'
}, {
  question: '¿Sirve si no tengo formación clínica formal?',
  answer: 'Sí. Está diseñado exactamente para eso. El lenguaje es de campo, las herramientas son prácticas y todo está pensado para que lo puedas usar sin necesitar un título universitario en psicología.'
}, {
  question: '¿Funciona si trabajo en una ONG con pocos recursos?',
  answer: 'Sí. Las fichas son imprimibles, el material es descargable y todo está pensado para el trabajo real en el contexto argentino, con o sin recursos institucionales.'
}, {
  question: '¿Los 6 bonos están incluidos en las dos ofertas?',
  answer: 'Sí. Los 6 bonos están incluidos en las dos ofertas sin costo adicional. La diferencia entre las dos opciones son los Volúmenes 7 y 8 premium.'
}, {
  question: '¿Puedo usarlo si trabajo con adicciones distintas a la ludopatía?',
  answer: 'Sí. Los seis volúmenes principales aplican a cualquier adicción conductual. Y si querés herramientas específicas para compras compulsivas, pantallas o conductas sexuales compulsivas, el Pack Premium incluye el Volumen 7 dedicado a eso.'
}, {
  question: '¿Qué diferencia tiene con material gratuito que encuentro en internet?',
  answer: 'El material gratuito que existe en español sobre adicciones conductuales es escaso, teórico y no está adaptado al rol del orientador argentino. Este sistema está construido específicamente para el trabajo de campo, con fichas imprimibles, protocolos paso a paso y lenguaje rioplatense. No vas a encontrar esto en ningún otro lado.'
}, {
  question: '¿Puedo compartirlo con mi equipo de trabajo?',
  answer: 'El material es de uso personal. Si trabajás en equipo y querés que varios orientadores lo tengan, cada uno necesita su propio acceso.'
}, {
  question: '¿Por qué elegir el Pack Premium y no el estándar?',
  answer: 'Si solo trabajás con ludopatía, el sistema estándar es completo y suficiente. Si empezás a ver personas con otras adicciones conductuales o querés armar un grupo, el Pack Premium te da exactamente eso en los Volúmenes 7 y 8.'
}, {
  question: '¿Tiene garantía real?',
  answer: 'Sí. 7 días, sin preguntas. Si abrís el material y sentís que no es lo que necesitabas, te devolvemos el 100% del dinero. Sin formularios ni demoras.'
}];
export function FAQ() {
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);
  return <section className="py-10 md:py-20 px-4 bg-white" data-id="element-118">
      <div className="max-w-4xl mx-auto" data-id="element-119">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 md:mb-12" data-id="element-120">
          <p className="text-xs md:text-sm text-gray-600 uppercase tracking-wide mb-1 md:mb-2" data-id="element-121">
            DUDAS COMUNES
          </p>
          <h2 className="font-serif text-2xl md:text-4xl font-bold text-navy-dark" data-id="element-122">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-3 md:space-y-4" data-id="element-123">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="bg-cream-light rounded-lg shadow-sm overflow-hidden" data-id="element-124">
              <button onClick={() => setExpandedIndex(expandedIndex === index ? null : index)} className="w-full p-4 md:p-6 text-left flex items-center justify-between gap-3 md:gap-4 hover:bg-cream-bg transition-colors" data-id="element-125">
                <span className="font-bold text-navy-dark text-sm md:text-base" data-id="element-126">
                  {faq.question}
                </span>
                <ChevronDown className={`w-4 h-4 md:w-5 md:h-5 text-gold flex-shrink-0 transition-transform ${expandedIndex === index ? 'rotate-180' : ''}`} data-id="element-127" />
              </button>

              <AnimatePresence data-id="element-128">
                {expandedIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-129">
                    <div className="px-4 md:px-6 pb-4 md:pb-6 text-gray-700 text-sm md:text-base" data-id="element-130">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}